import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	errorContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '100vh',
		padding: 20,
		backgroundColor: THEME.colors.background.main,
	},
	errorContent: {
		textAlign: 'center',
	},
	errorTitle: {
		fontSize: 28,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.md,
	},
	errorMessage: {
		fontSize: THEME.typography.fontSizes.md,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
	},
	refreshPrompt: {
		marginTop: THEME.spacing.lg,
		textAlign: 'center',
	},
});
